import { request } from '@umijs/max';

/** 管理员登录 */
export async function login(body: API.LoginParams) {
  return request<API.Response<API.LoginResult>>('/api/auth/login', {
    method: 'POST',
    data: body,
  });
}

/** 退出登录 */
export async function logout() {
  return request<API.Response>('/api/auth/logout', {
    method: 'POST',
  });
}

/** 获取当前用户信息 */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<API.Response<API.CurrentUser>>('/api/auth/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 刷新令牌 */
export async function refreshToken() {
  return request<API.Response<{ token: string; token_type: string }>>('/api/auth/refresh', {
    method: 'POST',
  });
}
